import posthog from "posthog-js";
import { USER, TEST } from "./types";
import { PATHS } from "../utills/paths";
import { getValidJSON } from "../utills/common";
import { PLAN_FEE_TYPE, YESNO } from "./constants";
import { getUserAccessObject } from "../utills/dashboard_functions";
import axios, { axiosCall, axiosCallNest, axiosCallYii } from "../utills/axios";

// User actions
export const userActions = {
  listCountry,
  getUserInfo,
  updateAIOptIn: (isOptIn, workspaceId = "") =>
    axiosCall(`auth/updateAIOptIn?workspace_id=${workspaceId}`, "post", { ai_opt_in: isOptIn }),
  // User Profile
  updateUserName: (data) => axiosCallNest("users/names", "put", data),
  updateUserPassword: (data) => axiosCall("auth/changePassword", "post", data),
  updateUserProfilePic: (data) => axiosCallNest("users/profile-picture", "put", data, { "Content-Type": "multipart/form-data" }),
  deleteUserProfilePic: () => axiosCallNest("users/profile-picture", "delete"),
  updateTimezone: (timezone = "") => axiosCall("user/updateUserTimeZone", "post", { timezone }),
  updateUserBasicInfo: (data) => axiosCall("auth/addUserBasicInfo", "post", data),
  // Global Settings
  updateOrganization: (data) => axiosCallNest("organization", "put", data, { "Content-Type": "multipart/form-data" }),
  updateAdvancedSettings: (workspaceId, data) =>
    axiosCallNest(`workspaces/${workspaceId}/advance`, "put", data, { "Content-Type": "multipart/form-data" }),
  disconnectIntegration: (workspaceId, data) =>
    axiosCallYii(`/organization/workspace/disconnectIntegration?id=${workspaceId}`, "post", data),
  disconnectFigma: (workspaceId) => axiosCall(`task/figmaDisconnect?workspace_id=${workspaceId}`),
  // Organisation
  getOrganization: (orgsId = "") => axiosCallNest(`organizations/${orgsId}`, "get"),
  getOrganizationCards: (orgsId = "") => axiosCallNest(`organizations/${orgsId}/cards`, "get"),
  updateOrganizationBillingAddress: (data = {}) => axiosCallNest(`organization/address`, "put", data),
  getOrganizationBillingAddress: (orgsId = "") => axiosCallNest(`organizations/${orgsId}/addresses/default`, "get"),
  addOrganizationCard: (orgsId = "", data = {}) => axiosCallNest(`organizations/${orgsId}/cards`, "post", data),
  deleteOrganizationCard: (orgsId = "", cardId = "") => axiosCallNest(`organizations/${orgsId}/cards/${cardId}`, "delete"),
  updateOrganizationDefaultCard: (orgsId = "", cardId = "") => axiosCallNest(`organizations/${orgsId}/cards/${cardId}/default`, "put"),
  getOrganizationInvoices: (orgsId) => axiosCallNest(`organizations/${orgsId}/invoices`, "get"),
  getOrganizationInvoiceUpcoming: (orgsId) => axiosCallNest(`organizations/${orgsId}/invoices/upcoming`, "get"),
  getInvoiceViewUrl: (orgsId, invoiceId) => axiosCallNest(`organizations/${orgsId}/invoices/${invoiceId}/url`, "get"),
  getOrganizationUsageHistory: (orgsId, m, y) => axiosCallNest(`organizations/${orgsId}/credits/history?month=${m}&year=${y}`, "get"),
  cancelOrganizationSubscription: (orgsId) => axiosCallNest(`organizations/${orgsId}/subscriptions`, "delete"),
  resumeOrganizationSubscription: (orgsId) => axiosCallNest(`organizations/${orgsId}/subscriptions/resume`, "put"),
  upgradeOrganizationSubscription: (orgsId, data) => axiosCallNest(`organizations/${orgsId}/subscriptions/upgrade`, "put", data),
  updateBrevoSubscription: (data) => axiosCall("user/updateBrevoSubscription", "post", data),
  getOrganizationPeople: (orgsId) => axiosCallNest(`organizations/${orgsId}/people`, "get"),
  updateOrganizationPeople: (orgsId, data) => axiosCallNest(`organizations/${orgsId}/people`, "put", data),
  deleteOrganizationPeople: (orgsId, data) => axiosCallNest(`organizations/${orgsId}/people`, "delete", data),
  getOrganizationPeopleInvited: (orgsId) => axiosCallNest(`organizations/${orgsId}/people/invites`, "get"),
  resendOrganizationPeopleInvite: (orgsId, inviteId) =>
    axiosCallNest(`organizations/${orgsId}/people/invites/${inviteId}/resend`, "post"),
  deleteOrganizationPeopleInvite: (orgsId, inviteId) => axiosCallNest(`organizations/${orgsId}/people/invites/${inviteId}`, "delete"),
  activateOrganizationDormantUser: (orgsId, data) => axiosCallNest(`organizations/${orgsId}/people/dormant/activate`, "put", data),
  quoteOrganizationSubscriptionSeats: (orgsId, data) =>
    axiosCallNest(`organizations/${orgsId}/subscriptions/seats/quote`, "put", data),
  updateOrganizationSubscriptionSeats: (orgsId, data) => axiosCallNest(`organizations/${orgsId}/subscriptions/seats`, "put", data),
  // Credits
  topUpCredits: (orgsId, data) => axiosCallNest(`organizations/${orgsId}/credits/topup/panel`, "post", data),
  getBalances: (orgsId, workspaceId) => axiosCallNest(`organizations/${orgsId}/credits/balances?workspaceId=${workspaceId}`, "get"),
  getTopUpPanelQuote: (orgsId, data) => axiosCallNest(`organizations/${orgsId}/credits/topup/panel/quote`, "post", data),
  getSubscriptionQuote: (orgsId, data) => axiosCallNest(`organizations/${orgsId}/subscriptions/upgrade/quote`, "post", data),
  // Projects
  getWorkspaceProjects: (workspaceId) => axiosCallNest(`workspaces/${workspaceId}/projects`, "get"),
  // Most popular templates
  getMostPopularTemplates: () => axiosCall("templates/getPopularTemplates", "get"),
  // Workspace
  getWorkspace: (workspaceId) => axiosCallNest(`workspaces/${workspaceId}`, "get"),
  updateWorkspaceName: (workspaceId, data) => axiosCallNest(`workspaces/${workspaceId}/name`, "patch", data),
  getWorkspaceMembers: (workspaceId) => axiosCallNest(`workspaces/${workspaceId}/members`, "get"),
  updateWorkspaceMember: (workspaceId, memberId, data) => axiosCallNest(`workspaces/${workspaceId}/members/${memberId}`, "put", data),
  deleteWorkspaceMember: (workspaceId, memberId) => axiosCallNest(`workspaces/${workspaceId}/members/${memberId}`, "delete"),
  getWorkspaceInvitesPending: (workspaceId) => axiosCallNest(`workspaces/${workspaceId}/invites/pending`, "get"),
  getWorkspaceRequestsPending: (workspaceId) => axiosCallNest(`workspaces/${workspaceId}/requests/pending`, "get"),
  sendWorkspaceInvites: (workspaceId, data) => axiosCallNest(`workspaces/${workspaceId}/invites`, "post", data),
  deleteWorkspaceInvite: (workspaceId, inviteId) => axiosCallNest(`workspaces/${workspaceId}/invites/${inviteId}`, "delete"),
  getWorkspaceNotifications: (workspaceId) => axiosCallNest(`workspaces/${workspaceId}/notifications`, "get"),
  markWorkspaceNotificationAsRead: (workspaceId, notificationId) =>
    axiosCallNest(`workspaces/${workspaceId}/notifications/${notificationId}/read`, "put"),
  activateWorkspaceDormantUser: (workspaceId, memberId) =>
    axiosCallNest(`workspaces/${workspaceId}/members/${memberId}/dormant/activate`, "put"),
  // Invites
  acceptInvite: (uuid) => axiosCallNest(`invites/${uuid}/accept`, "post", {}, {}, true),
  rejectInvite: (uuid) => axiosCallNest(`invites/${uuid}/reject`, "put"),
  requestInviteAsEditor: (workspaceId, data) => axiosCallNest(`invites/${workspaceId}/requests/editor`, "post", data, {}, true),
  requestInviteAsCollaborator: (workspaceId, data) =>
    axiosCallNest(`invites/${workspaceId}/requests/collaborator`, "post", data, {}, true),
  // Recent studies
  getRecentStudies: (workspaceId, data) => axiosCallNest(`workspaces/${workspaceId}/studies/recent`, "post", data),
  // User Availability
  getUserAvailability: () => axiosCall(`moderated/getAvailability`, "get"),
  saveUserAvailability: (data) => axiosCall(`moderated/saveAvailability`, "post", data),
  // Analysis space tags
  fetchTags: (workspaceId) => axiosCall(`site/fetchTags?workspace_id=${workspaceId}`, "get"),
  addAnalysisTag: (data) => axiosCall(`site/addAnalysisSpaceTag`, "post", data),
  updateInterestingTags: (data) => axiosCall("site/updateInterestingTags", "post", data),
  // Feedback
  checkFeedbackPrompt: (product) => axiosCall(`feedback/check?product=${product}`, "get"),
  submitFeedback: (data) => axiosCall(`feedback/submit`, "post", data),
  // Credit Usage
  getCreditUsage: (orgId, workspaceId, resourceType) =>
    axiosCallNest(`organizations/${orgId}/creditUsage?resourceType=${resourceType}&workspaceId=${workspaceId}`, "get"),
  // NDAs
  fetchNdas: (workspaceId) => axiosCallNest(`nda/${workspaceId}`, "get"),
  deleteNda: (workspaceId, ndaId) => axiosCallNest(`nda/${workspaceId}/${ndaId}`, "delete"),
  uploadNdas: (workspaceId, data) =>
    axiosCallNest(`nda/${workspaceId}/upload`, "post", data, { "Content-Type": "multipart/form-data" }),
  detectFigmaAccessCheck: (prototypeUrl) => axiosCallNest(`figma-access/check`, "post", { prototypeUrl }),
  // Global Configs
  updateGlobalConfigs: (data) => axiosCall("auth/updateGlobalConfig", "post", data),
};

// Get user Info
export function getUserInfo(
  setLoading = false,
  fetchReqDetails = false,
  fetchBalances = false,
  fetchProjects = false,
  fetchBillings = false
) {
  return async (dispatch) => {
    if (setLoading) dispatch({ type: USER.UPDATE, payload: { isLoading: true } });

    try {
      const data = {};

      // User Info
      const { data: user } = await axios.get(`auth/me`);
      const localWid = localStorage.getItem("workspaceId");

      if (user) {
        // Admin or Support Account
        user.isAdminOrSupportAccount = !!user?.isAdmin || !!user?.isSupportAccount || false;

        // Post hog - user identification
        console.log("Re-authentication after inactivity.");
        posthog.identify(user.id, { user_id: user.id, account_type: "customer", email: user.email });

        // Get User Availability
        const { data } = await userActions.getUserAvailability();
        const { user_id = 0, availability_json = null } = data || {};
        user.hasAvailabilityDetails = Number(user?.id) === Number(user_id);
        user.availability = availability_json ? JSON.parse(availability_json) : {};

        // Global Configs
        user.global_config = getValidJSON(user?.global_config) || {};
      }

      // Validate Workspace ID
      const isValidWorkspaceId = localWid ? user?.workspaces?.some((w) => Number(w.id) === Number(localWid)) : false;
      const workspaceId = isValidWorkspaceId ? localWid : user?.defaultWorkspaceId;

      // Data to dispatch
      const dataToDispatch = { type: USER.UPDATE, payload: { isLoading: false, user, ...data } };

      // Fetch Workspace Details
      if (workspaceId) {
        dispatch(updateWorkspace(workspaceId, dataToDispatch, { fetchReqDetails, fetchBalances, fetchProjects, fetchBillings }));
      } else dispatch(dataToDispatch);
    } catch (error) {
      const { status, data } = error?.response || {};
      dispatch({ type: USER.UNAUTHORIZED, payload: { status, message: data?.error } });
    }
  };
}

// Get Countries
export function listCountry() {
  return async (dispatch) => {
    try {
      const headers = {
        headers: {
          HTTP_X_USERNAME: process.env.REACT_APP_HTTP_X_USERNAME,
          HTTP_X_PASSWORD: process.env.REACT_APP_HTTP_X_PASSWORD,
        },
      };
      const { data } = await axios.get(`user/listCountry`, headers);

      dispatch({ type: USER.UPDATE_DATA, payload: { countries: data } });
    } catch (error) {
      console.log("error in fetching countries", error);
    }
  };
}

// Logout
export const logout = () => (dispatch) => dispatch({ type: USER.RESET });
export const resetState = () => (dispatch) => dispatch({ type: USER.RESET });
export const updateState = (payload) => (dispatch) => dispatch({ type: USER.UPDATE, payload });

// Toggle AI Opt In
export function toggleAIOptInUserState(isOptIn, openAiOptinPopup = false) {
  return async (dispatch) => {
    dispatch({ type: USER.TOGGLE_AIOPTIN, payload: isOptIn });
    dispatch({ type: USER.UPDATE, payload: { openAiOptinPopup } });
  };
}

// Fetch Notifications
export function fetchNotifications(workspaceId) {
  return async (dispatch) => {
    try {
      const result = await userActions.getWorkspaceNotifications(workspaceId);
      dispatch({ type: USER.UPDATE, payload: { notifications: result?.data?.notifications || [] } });
    } catch (error) {
      console.log("error in fetching notifications", error);
    }
  };
}

// Update Workspace Details
export function updateWorkspace(workspaceId, dataToDispatch = null, fetchParams = {}) {
  const { fetchReqDetails = false, fetchBalances = false, fetchProjects = false, fetchBillings = false } = fetchParams;
  if (!workspaceId) return;

  return async (dispatch) => {
    try {
      // Fetch Workspace Details
      dispatch({ type: USER.UPDATE_DATA, payload: { isFetchingWorkspace: true } });

      const data = {};
      const res = await userActions.getWorkspace(workspaceId);
      data.access = res?.data?.access || {};
      data.prices = res?.data?.prices || {};
      data.workspace = res?.data?.workspace || {};
      data.creditPrices = res?.data?.creditPrices || {};
      data.userAccess = getUserAccessObject(data?.access);

      const organization = data?.workspace?.organization || null;
      data.subscription = organization?.subscription || {};
      data.allowedFeatures = organization?.allowedFeatures || {};
      data.allowedTestTypes = organization?.allowedTestTypes || {};
      data.userPrevTaskUrlAllowed = Number(data?.workspace?.use_prevtask_url) === YESNO.YES; // Enable Feature Flag

      // Organization ID
      const orgsId = organization?.id;
      const { isAdmin = false, isOwner = false, isOrganizationAdmin = false } = data?.userAccess;

      // Fetch Required Details
      if (fetchReqDetails || fetchBillings) {
        if (isOwner || isOrganizationAdmin) {
          // Cards
          const result3 = await userActions.getOrganizationCards(orgsId);
          data.billings = result3?.data;

          // Address
          if (data?.billings) {
            const result4 = await userActions.getOrganizationBillingAddress(orgsId);
            data.billings.address = result4?.data?.address || "";
          }

          if (fetchReqDetails) {
            // Invoices
            const result5 = await userActions.getOrganizationInvoices(orgsId);
            data.invoices = result5?.data?.invoices || [];

            // Fetch Upcoming Invoice
            if (data?.subscription && Number(data?.subscription?.plan?.fee_type) === PLAN_FEE_TYPE.PAID) {
              const result7 = await userActions.getOrganizationInvoiceUpcoming(orgsId);
              data.upcomingInvoice = result7?.data?.invoice || null;
            } else data.upcomingInvoice = null;

            // Usage history
            const d = new Date();
            const result6 = await userActions.getOrganizationUsageHistory(orgsId, d?.getMonth() + 1, d?.getFullYear());
            data.usageHistory = { date: d, isFetching: false, history: result6?.data?.history || [] };

            // Organization People && People Invited
            if (data?.workspace?.organization) {
              // People
              const result = await userActions.getOrganizationPeople(orgsId);
              data.organizationPeople = result?.data?.people || [];

              // People Invited
              const result2 = await userActions.getOrganizationPeopleInvited(orgsId);
              data.organizationPeopleInvited = result2?.data?.invites || [];
            }
          }
        }

        // Workspace Members
        if (fetchReqDetails && data?.workspace) {
          const result8 = await userActions.getWorkspaceMembers(workspaceId);
          data.workspace.members = result8?.data?.members || [];
          data.workspace.orgMembers = result8?.data?.orgMembers || [];

          // Workspace Invites Pending / Requests Pending
          if (isOwner || isAdmin) {
            const result9 = await userActions.getWorkspaceInvitesPending(workspaceId);
            data.workspace.invitesPending = result9?.data?.invites || [];

            // Workspace Requests Pending
            const result10 = await userActions.getWorkspaceRequestsPending(workspaceId);
            data.workspace.requestsPending = result10?.data?.requests || [];
          }
        }
      }

      // Balances
      if (fetchBalances) {
        const result7 = await userActions.getBalances(orgsId, workspaceId);
        data.balances = result7?.data || [];
      }

      // Fetch user projects
      if (fetchProjects) {
        const res2 = await userActions.getWorkspaceProjects(workspaceId);
        data.projects = res2?.data?.projects || [];
      }

      // Tags
      const { data: tags } = await userActions.fetchTags(workspaceId);
      data.tags = tags || [];

      // NDAs
      const ndaResult = await userActions.fetchNdas(workspaceId);
      data.ndas = ndaResult?.data || [];

      // Credit Usage
      if (!data.userAccess?.isCollaborator) {
        const resourceType = fetchReqDetails ? "organization" : organization?.workspaces?.length > 1 ? "workspace" : "organization";
        const creditUsageRes = await userActions.getCreditUsage(orgsId, workspaceId, resourceType);
        data.creditUsage = creditUsageRes?.data || {};
      }

      // Set the workspace ID in localStorage
      localStorage.setItem("workspaceId", workspaceId);

      dispatch({ type: USER.UPDATE, payload: { ...data, isFetchingWorkspace: false } }); // Update Workspace
      dispatch({ type: TEST.UPDATE, payload: { isLoading: false } }); // Stop TBT Test Loading

      // Dispatch any additional data if provided
      if (dataToDispatch) dispatch(dataToDispatch);
    } catch (error) {
      console.log("error in fetching workspace", error);
    }
  };
}

// List of Timezones
export function listTimezones() {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(`user/listTimezones`);

      // Format the timezones data
      const timezones = Object.keys(data).map((key) => ({
        value: key,
        label: data[key],
      }));

      dispatch({ type: USER.UPDATE_DATA, payload: { timezones } });
    } catch (error) {
      console.log("error in fetching timezones", error);
    }
  };
}

export async function getFigmaStatus(workspaceId) {
  const { data } = await axios.get(`/task/figmaStatus?workspace_id=${workspaceId}`);
  return !!(data && data.connected);
}

export function openFigmaOAuthPopup(workspaceId) {
  return new Promise((resolve, reject) => {
    const w = 520,
      h = 700;
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    var width = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
    var height = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
    const left = (width - w) / 2 + dualScreenLeft;
    const top = (height - h) / 2 + dualScreenTop;

    const url = PATHS.getUrl(
      `/api/task/figmaConnect?popup=1&workspace_id=${workspaceId}&origin=${encodeURIComponent(window.location.origin)}`
    );

    const popup = window.open(url, "figmaOAuth", "scrollbars=yes,width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);

    if (!popup) {
      reject(new Error("Popup blocked. Please allow popups."));
      return;
    }

    var gotMessage = false;
    var done = false;

    function cleanup() {
      if (done) return;
      done = true;
      window.removeEventListener("message", onMessage);
      try {
        clearInterval(poll);
      } catch (e) {}
      try {
        popup.close();
      } catch (e) {}
    }

    async function onMessage(ev) {
      if (ev.origin !== window.location.origin) return;
      if (!ev.data || ev.data.source !== "figma-oauth") return;

      gotMessage = true;
      // Optional: verify with backend
      if (ev.data.status === "success") {
        try {
          const connected = await getFigmaStatus(workspaceId);
          if (connected) {
            cleanup();
            resolve();
          } else {
            cleanup();
            reject(new Error("Connected, but status not confirmed"));
          }
        } catch (e) {
          cleanup();
          reject(new Error("Status check failed"));
        }
      } else {
        cleanup();
        reject(new Error(ev.data.message || "OAuth error"));
      }
    }

    window.addEventListener("message", onMessage);

    // Fallback: detect popup close and double-check status before rejecting
    var poll = setInterval(async function () {
      if (!popup || popup.closed) {
        clearInterval(poll);
        window.removeEventListener("message", onMessage);

        // small grace period to allow late postMessage delivery in some browsers
        setTimeout(async function () {
          if (gotMessage) return; // message already handled
          try {
            const connected = await getFigmaStatus(workspaceId);
            if (connected) {
              cleanup();
              resolve();
            } else {
              cleanup();
              reject(new Error("The sign-in window was closed before finishing. Please try again."));
            }
          } catch (e) {
            cleanup();
            reject(new Error("Popup closed and status check failed"));
          }
        }, 250);
      }
    }, 400);
  });
}

export async function getMiroStatus(workspaceId) {
  const { data } = await axios.get(`/testCommon/miroStatus?workspace_id=${workspaceId}`);
  return data;
}
